export default function dataSetCustom(action){

   
    this.dataDispatch(action);
   

}